import styled from "styled-components";
import { IconUpDown } from "../../SideBar/styles";
import { Link } from "react-router-dom";

export const StyledLink = styled(Link)`
  animation: ${IconUpDown} 1s linear infinite;
  cursor: pointer;
  text-decoration: underline;
  color: var(--primary-text);
  display: flex;
  align-items: center;
  svg {padding-right: 5px;}
`;
export const StyledNotificationTable = styled.div`
  h1.page-title{
    margin-bottom:1rem;
  }
    .subHeader {
      display: flex;
      justify-content: space-between;
    }
    header.tma_notification_table_header{
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-bottom: 1rem;
        .tma_notifications_actions{
            display: flex;
            gap: 0.5rem;
            align-items:center;
            flex-wrap: wrap;
            button.tma_app_btn{
                height:40px;
                border-color: var(--primary-text);
                color: var(--primary-text);
                &:hover {
                  background-color: var(--primary-text);
                  color: white;
                }
            }
            p.hide-text{
                visibility:hidden;
            }
        }
        display:flex;
        align-items:center;
        gap:0.5rem;
        .flex-end{
            display: flex;
            align-items: center;
            gap: 0.5rem;
            svg {
              width: 28px;
              height: 28px;
              fill: var(--primary-text);
              cursor: pointer;
              transition: all 0.5s ease-in-out;
              &:hover {
                fill: var(--primary-text-hover);
                padding: 0.1rem;
              }
            }
        }
    }
  .ag-row.ag-row-noti-unread {
    .ag-cell {
      color: #333;
      font-weight: bold;
    }
  }

  .tma_notifcation_container {
    display: flex;
    gap: 0.5rem;
    @media (max-width: 980px) {
      flex-direction: column;
    }
    aside.tma_facets_content {
      flex-basis: inherit;
      max-width: 260px;
      height: calc(100vh - 200px);
      label {font-size: 14px;}
      @media (max-width: 980px) {
        max-width: 100%;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
      }
    }
    .tma_notification-table_wrapper {
      height: 520px;
      flex: 1;
    }
  }
    .tma_notification_table {
  height: calc(100vh - 255px);
  width: calc(100% - 260px);
  .ag-row{
    width:100vw;
  }
  @media (max-width: 1030px) {
    height: calc(100vh - 275px);
  }
  @media (max-width: 980px) {
     width: 100%;
     height: calc(100vh - 465px);
  }
  @media (max-width: 767px) {
     width: 100%;
     height: calc(100vh - 505px);
  }
  @media (max-width: 480px) {
     width: 100%;
     height: calc(100vh - 537px);
  }
  .ag-theme-material {
    .ag-theme-checkboxStyle-1.ag-theme-iconSet-2.ag-theme-tabStyle-3.ag-theme-inputStyle-4 {
      overflow-x: auto;
      border: 1px solid #ddd;
      border-radius: 3px;
      .ag-root-wrapper.ag-ltr.ag-layout-normal {
        min-width: 1250px;
        border: none;
        border-radius: 0px;
        .ag-header-cell {
        .ag-header-cell-label {
          font-size: 13px;
          font-weight: 500;
        }
            &:last-child {
              .ag-header-cell-resize {
                &:after {display: none;}
              }
            }
        }
      }
    }
    .ag-center-cols-viewport {
    .ag-cell {
      font-size: 13px;
      &:last-child {
      div {gap: 0.5rem; align-items: center; display: flex; height: 100%;}
      button.tma_action_icon {
        display: flex;
        // border: 1px solid var(--primary-text);
        // border-radius: 100px;
        // background-color: var(--primary-text);
        // padding: 0.3rem;
        transition: all 0.3s ease-in-out;
        svg {height: 18px; width: 18px; fill: var(--primary-text);}
        &.delete {
        // background-color: var(--failed);
        // border-color: var(--failed);
          svg {
            fill: var(--failed);
          }
        }
          &:hover 
      }
      }
    }
      .ag-center-cols-container {
        .ag-row-no-focus.ag-row {
          &:nth-child(2n+1) {
            background-color: #f5f5f5;
          }
        }
      }
    }
      .MuiTablePagination-root {
        .MuiToolbar-root {padding: 0 !important;}
      }
  }
  &.projects {
    .ag-theme-material {
    .ag-theme-checkboxStyle-1.ag-theme-iconSet-2.ag-theme-tabStyle-3.ag-theme-inputStyle-4 {
      overflow-x: auto;
      border: 1px solid #ddd;
      border-radius: 3px;
      .ag-root-wrapper.ag-ltr.ag-layout-normal {
        min-width: 760px;
        border: none;
        border-radius: 0px;
        .ag-header-cell {
        .ag-header-cell-label {
          font-size: 13px;
          font-weight: 500;
        }
            &:last-child {
              .ag-header-cell-resize {
                &:after {display: none;}
              }
            }
        }
      }
    } 
    } 
  }
}
`;
export const StyledNotificationBadge = styled.div`
  width: auto;
  text-align: left;
  margin: 0.5rem;
  height: 32px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #333;
  &.tma-notification {
    color: #333;
  }
  &.tma-alert {
    color: red;
  }
`;
export const StyledNotificationFacet = styled.aside`
  padding: 1rem;
  border: 1px solid #ccc;
  .tma__input_container {
    .MuiInputBase-root {
      height: 32px;
    }
    p.MuiFormHelperText-root {
      margin-left: 0;
      white-space:nowrap;
      font-size:12px;
    }
  }
  section.tma_facet-section {
    padding: 0;
    &:last-child {
      @media (max-width: 980px) {
            display: flex;
            align-items: flex-end;
            justify-content: flex-start;
      }
    }
    @media (max-width: 980px) {
      width: calc(50% - 1rem);
    }
    h3 {
      color: var(--label-text);
      font-size: 16px;
      margin: 0.5rem 0;
    }
      button {margin: 1rem 0 0.3rem; height:40px;
                border-color: var(--primary-text);
                color: var(--primary-text);
                &:hover {
                  background-color: var(--primary-text);
                  color: white;
                }}
  }
  section.tma_facet-section:after{
    height: 1px;
    content: "";
    display: block;
    width: 100%;
    margin-top: 0.5rem;
    background-color: #ddd;
    @media (max-width: 980px) {display: none;}
  }
  p.tma_blue-highlighter {
    color: var(--pro-blue);
    display: flex;
    gap: 0.5rem;
    font-size: 14px;
  }
  .tma_type_highlighter {
    margin-top: 0.5rem;
  }
  .form-control {
    display: flex;
    align-items: anchor-center;
    gap: 0.5rem;
    position: relative;
    input[type="checkbox"] {
      display: none;
    }
    label{
        cursor:pointer;
    }
    label:before {
      content: "";
      -webkit-appearance: none;
      background-color: transparent;
      border: 1px solid #ccc;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
      inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
      padding: 7px;
      display: inline-block;
      position: relative;
      vertical-align: middle;
      cursor: pointer;
      margin-right: 14px;
    }
    input[type="checkbox"]:checked + label:after {
      content: "";
      display: block;
      position: absolute;
      top: 3px;
      left: 4px;
      width: 6px;
      height: 10px;
      border: solid #0079bf;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
      scale: 0.8;
    }
  }
 .checkbox-highlighter{
    padding:0.35rem;
    color:#fff;
    border-radius:5px;
    margin-bottom:0.5rem;
    label{
        color:#fff;
        cursor:pointer;
        position:relative;
        top:2px;
    }
    label:before{
        background-color:#fff;
    }
     input[type="checkbox"]:checked + label:after {
        content: "";
        display: block;
        position: absolute;
        top: 2px;
        left: 5px;
        width: 5px;
        height: 10px;
        border: 2px solid #0079bf;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        scale: 1;
    }
    &.noti-highlighter{
        background-color:var(--primary-button-bg);
    }
    &.alert-highlighter{
       background-color: #ae0000;
    }
 }
`;
